<template>
  <div>
    <v-data-table
      disable-sort
      :loading="loadingTable"
      :headers="headers"
      :items="checkoutsFiltered"
      class="elevation-1"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15, 50],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Vendas PDV no Caixa</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-badge
            :content="bagFilter"
            :value="bagFilter"
            bordered
            color="error"
            overlap
          >
            <v-btn
              large
              outlined
              rounded
              color="primary"
              @click="dialogFilter = true"
            >
              <v-icon>{{ icons.mdiFilter }}</v-icon>filtros
            </v-btn>
          </v-badge>
          <v-spacer></v-spacer>
          <v-text-field
            :append-icon="icons.mdiMagnify"
            class="mt-6"
            v-model="search"
            dense
            rounded
            outlined
            label="Pesquisar"
            placeholder="PDV ou cliente"
            clearable
            style="max-width: 450px;"
            @click:append="confirmSearch()"
            @keyup.enter="confirmSearch()"
            @click:clear="clearSearch()"
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:item.pdv="{ item }">
        {{ item.pdv_order && item.pdv_order.pdv ? item.pdv_order.pdv.description : '-' }}
      </template>

      <template v-slot:item.operador="{ item }">
        {{ item.checkout_by && item.checkout_by.name ? item.checkout_by.name : '-' }}
      </template>

      <template v-slot:item.cliente="{ item }">
        {{ item.guest_fiscal ? item.guest_fiscal.name : '-' }}
      </template>

      <template v-slot:item.date_sale="{ item }">
        {{ formatDateTime(item.date_sale) }}
      </template>

      <template v-slot:item.itens="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >
              {{ item.checkout_pdv_items ? item.checkout_pdv_items.length : 0 }} item(s)
            </span>
          </template>
          <div v-if="item.checkout_pdv_items && item.checkout_pdv_items.length">
            <div
              v-for="(prod, i) in item.checkout_pdv_items"
              :key="i"
            >
              {{ prod.quantity }}x {{ prod.product ? prod.product.description : '-' }} — R$ {{ formatMoney(prod.total_amount) }}
            </div>
          </div>
        </v-tooltip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              :loading="item.loading_print"
              :disabled="item.loading_print"
              color="secondary"
              v-bind="attrs"
              v-on="on"
              @click="printVoucher(item)"
            >
              <v-icon>{{ icons.mdiPrinter }}</v-icon>
            </v-btn>
          </template>
          <span>Imprimir Voucher</span>
        </v-tooltip>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <!-- DIALOG FILTRO -->
    <v-dialog
      v-model="dialogFilter"
      width="700"
    >
      <v-card>
        <BarTitleDialog
          title="FILTROS"
          @close="dialogFilter = false"
        />
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="filter.date_start"
                outlined
                type="date"
                label="Data Início"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="filter.date_end"
                outlined
                type="date"
                label="Data Fim"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-left">
              <v-btn
                text
                color="error"
                x-large
                @click="clearFilter()"
              >
                limpar filtros
              </v-btn>
            </v-col>
            <v-col class="text-right">
              <v-btn
                text
                color="secondary"
                x-large
                @click="dialogFilter = false"
              >
                FECHAR
              </v-btn>
              <v-btn
                color="primary"
                class="ml-2"
                x-large
                @click="confirmFilter()"
              >
                aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiMagnify, mdiPrinter, mdiFilter } from '@mdi/js'
import axios from '@axios'
import NoDataTable from '@/components/NoDataTable.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  name: 'PdvSalesCash',

  components: {
    NoDataTable,
    BarTitleDialog,
  },

  data: () => ({
    search: '',
    searchApplied: '',
    filter: {
      date_start: new Date().toISOString().slice(0, 10),
      date_end: new Date().toISOString().slice(0, 10),
    },
    dialogFilter: false,
    loadingTable: false,
    checkouts: [],
    icons: { mdiMagnify, mdiPrinter, mdiFilter },
    headers: [
      { text: 'PDV', value: 'pdv' },
      { text: 'OPERADOR', value: 'operador' },
      { text: 'CLIENTE', value: 'cliente' },
      { text: 'DATA/HORA', value: 'date_sale' },
      { text: 'ITENS', value: 'itens', sortable: false },
      {
        text: '', value: 'actions', sortable: false, align: 'end',
      },
    ],
  }),

  computed: {
    bagFilter() {
      let count = 0
      if (this.filter.date_start) count++
      if (this.filter.date_end) count++
      if (this.searchApplied && this.searchApplied.trim() !== '') count++

      return count
    },

    checkoutsFiltered() {
      if (!this.searchApplied || this.searchApplied.trim() === '') return this.checkouts

      const term = this.searchApplied.toLowerCase()

      return this.checkouts.filter(c => {
        const pdv = c.pdv_order && c.pdv_order.pdv ? c.pdv_order.pdv.description.toLowerCase() : ''
        const cliente = c.guest_fiscal ? c.guest_fiscal.name.toLowerCase() : ''

        return pdv.includes(term) || cliente.includes(term)
      })
    },

  },

  created() {
    this.loadCheckouts()
  },

  methods: {
    loadCheckouts() {
      this.loadingTable = true
      const params = {}
      if (this.filter.date_start) params.date_start = this.filter.date_start
      if (this.filter.date_end) params.date_end = this.filter.date_end

      axios.get('cash/pdv_checkouts', { params })
        .then(response => {
          this.checkouts = response.data.map(c => ({ ...c, loading_print: false }))
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar as vendas PDV.')
        })
        .finally(() => {
          this.loadingTable = false
        })
    },

    confirmFilter() {
      this.dialogFilter = false
      this.loadCheckouts()
    },

    clearFilter() {
      this.filter = {}
      this.search = ''
      this.searchApplied = ''
      this.dialogFilter = false
      this.loadCheckouts()
    },

    confirmSearch() {
      this.searchApplied = this.search
    },

    clearSearch() {
      this.search = ''
      this.searchApplied = ''
    },

    printVoucher(item) {
      item.loading_print = true
      axios.get(`pdv/checkout/export_pdf/${item.id}`, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `voucher_pdv_${item.id}.pdf`)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
        .catch(() => {
          this.$toast.error('Erro ao gerar o voucher.')
        })
        .finally(() => {
          item.loading_print = false
        })
    },

    formatMoney(value) {
      value = parseFloat(value)
      if (!isNaN(value)) {
        return value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }

      return '0,00'
    },

    formatDateTime(date) {
      if (!date) return '-'
      const result = new Date(date)

      return `${result.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
      } ${result.toLocaleTimeString('pt-BR')}`
    },
  },
}
</script>

<style scoped>
</style>
